import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import InviteUserModal from '@/components/modal/invites/invitesModal';
import InvitesTable from '@/components/table/invites/invitesTable';
import {
	DEFAULT_PAGE_SIZE,
	PAGE_SIZE_OPTIONS,
} from '@/components/utils/constants';
import { useUser } from '@/hooks/useUser';
import { ApiQueryKeys } from '@/interfaces/api/ApiQueryKeys';
import { ICollectionInvite } from '@/interfaces/api/invite/IInvite';
import { haggleApiService } from '@/services/haggle.service';
import { notificationService } from '@/services/notification.service';

const InvitedUsers = () => {
	const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
	const [pageNumber, setPageNumber] = useState(1);
	const [isModalOpen, setModalOpen] = useState(false);
	const { user } = useUser();

	const {
		data: invites,
		isLoading,
		isError,
		error,
		refetch,
	} = useQuery<ICollectionInvite>({
		queryKey: [ApiQueryKeys.getAllInvites, pageSize, pageNumber],
		queryFn: () =>
			haggleApiService.getAllInvites({
				params: {
					page: pageNumber,
					limit: pageSize,
					adminEmail: user?.username,
				},
			}),
		refetchOnWindowFocus: false,
	});

	if (isError && error instanceof Error) {
		notificationService.error(error.message);
	}

	const handleInviteUser = () => {
		setModalOpen(true);
	};

	const handleCloseModal = () => {
		setModalOpen(false);
	};

	const pagination = {
		pageSize,
		pageNumber,
		pageCount: invites?.pageCount || 0,
		itemCount: invites?.itemCount || 0,
		pageSizeOptions: PAGE_SIZE_OPTIONS,
		setPageSize,
		setPageNumber,
	};

	return (
		<div
			className="flex flex-col justify-center items-center w-full"
			data-test="invited-users"
		>
			{isLoading && <div>Loading...</div>}

			{invites && !isLoading && (
				<InvitesTable
					invites={invites.data}
					pagination={pagination}
					refetch={refetch}
					onInviteUser={handleInviteUser}
				/>
			)}

			<InviteUserModal
				isOpen={isModalOpen}
				onClose={handleCloseModal}
				onSuccess={refetch}
			/>
		</div>
	);
};

export default InvitedUsers;
